<cca-utility-panel heading="Filters">
  <form [formGroup]="filtersForm" (ngSubmit)="apply()">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-one-half">
        <div
          govuk-text-input
          formControlName="searchTerm"
          hint="Target unit ID, target unit name, facility ID, site name or sector ID"
          widthClass="govuk-!-width-full"
        ></div>
      </div>

      <div class="govuk-grid-column-one-quarter">
        <div class="govuk-hint govuk-!-margin-bottom-1">Filter by workflow</div>
        <div
          govuk-select
          formControlName="requestType"
          [options]="workflowOptions()"
          widthClass="govuk-!-width-full"
        ></div>
      </div>

      <div class="govuk-grid-column-one-quarter">
        <div class="govuk-hint govuk-!-margin-bottom-1">Sort by</div>
        <div govuk-select formControlName="orderBy" [options]="sortOptions" widthClass="govuk-!-width-full"></div>
      </div>
    </div>

    <div class="govuk-grid-row">
      <div class="govuk-grid-column-one-quarter">
        <button govukButton type="submit" class="govuk-!-margin-right-3">Apply</button>
        <button govukSecondaryButton type="button" (click)="clear()">Clear</button>
      </div>
    </div>
  </form>
</cca-utility-panel>
